import React from 'react';
import ReactDOM from 'react-dom';
import Form from './Form';
import Button from '../Field_Components/Button/Button';
import { Page, Content, Footer, SafeAreaWrap } from '@beisen/chaos-ui';
import { getExtensionCmp } from '../util/extension';
import transLoader from '@beisen/i18n-translation-loader';
import { isInvisible } from '../util/componetState';

const defaultTranslation = {
    allFilters: '全部筛选',
    confirm: '确定',
    reset: '重置'
};
class SearchForm extends React.Component {
    constructor(props) {
        super(props);
        this.getSearchData = this.getSearchData.bind(this);
        this.handleResetFormData = this.handleResetFormData.bind(this);
        this.handleButtonToggleData = this.handleButtonToggleData.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.getSubCmpsArr = this.getSubCmpsArr.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.formatSearchFormData = this.formatSearchFormData.bind(this);
        this.handleSearchFormValidate = this.handleSearchFormValidate.bind(
            this
        );
        this.state = {
            isExpand: false
        };
        this.allClass = 'm-sys-arrowdown';
        this.searchData = {}; // 主要负责存放高级lookup的表单数据
        this.translation = Object.assign(
            {},
            defaultTranslation,
            transLoader({
                allFilters: 'toolsBar.allFilters',
                confirm: 'common.confirm',
                reset: 'common.reset'
            }),
            props.translation
        );
    }

    componentWillMount() {
        this.tag = 0;
        let sub_cmpsArr = this.props.sub_cmps.filter(item => {
            return item.cmp_data.searchdisplaystate != 'invisible';
        });
        const bizObj = this.props.biz_data;
        let bizKeys = Object.keys(bizObj) || [];
        let key = this.getKey(bizKeys, bizObj);
        if (!key) {
            return;
        }
        for (let i = 0, len = sub_cmpsArr.length; i < len; i++) {
            let item = sub_cmpsArr[i]['cmp_data']['biz_data_key'];
            if (!key) {
                break;
            }
            if (key && i >= 5) {
                this.allClass = 'm-sys-arrowup';
                this.setState({ isExpand: true });
                break;
            }
            if (key === item) {
                key = this.getKey(bizKeys, bizObj);
            }
        }
    }

    onTouchMove() {
        document.activeElement && document.activeElement.blur();
    }

    handlerSearchDataChange(getState, dispatch, val) {
        this.props.reloadTable(
            { searchData: this.formatSearchFormData(val.toJS()) },
            'fromSearch'
        );
    }

    componentDidMount() {
        this.firstLoad = true;
        this.props.actions.serchonload();
        this.watchSearchFormChange();
        let pageContent = ReactDOM.findDOMNode(this.refs.pageContent);
        let originHeight = window.innerHeight;
        pageContent &&
            pageContent.addEventListener('touchend', evt => {
                if (evt.target.tagName.toLowerCase() == 'input') {
                    setTimeout(() => {
                        pageContent.scrollTop =
                            pageContent.scrollTop +
                            (originHeight - window.innerHeight);
                    }, 300);
                }
            });
    }

    watchSearchFormChange() {
        if (window.StoreEventEmitter) {
            new window.StoreEventEmitter().addEventListener(
                'MobileSearchWatcher',
                {
                    cmp_id: this.props.cmp_id,
                    valuePath: ['biz_data'],
                    rootName: 'indexPage'
                },
                {
                    cmp_id: this.props.cmp_id,
                    rootName: 'indexPage',
                    listener: this.handlerSearchDataChange.bind(this),
                    options: {}
                }
            );
        }
    }

    // 如果搜索表单滚动过，在搜索值发生变更后,表单应该保持当前的滚动状态
    componentDidUpdate() {
        const scrollTop = localStorage.getItem('searchFormListScrollTop');
        if (scrollTop) {
            const node = ReactDOM.findDOMNode(this);
            const listUl = node.querySelector('.list-block-ul');
            if (listUl) {
                listUl.scrollTop = parseInt(scrollTop);
                localStorage.removeItem('searchFormListScrollTop');
            }
        }
    }

    handleButtonToggleData(e) {
        document.activeElement && document.activeElement.blur(); //解决点击全部筛选时 输入类字段没有失去焦点 store没有更新值的问题
        if (this.allClass === 'm-sys-arrowdown') {
            this.allClass = 'm-sys-arrowup';
        } else {
            this.allClass = 'm-sys-arrowdown';
        }
        this.setState({ isExpand: !this.state.isExpand });
    }

    getKey(bizKeys, bizObj) {
        let key = bizKeys.shift();
        if (
            key &&
            (bizObj[key]['text'] === '' && bizObj[key]['value'] === '') &&
            this.tag <= bizKeys.length
        ) {
            key = this.getKey(bizKeys, bizObj);
            this.tag++;
        }
        this.tag = 1;
        return key;
    }

    getMetaFieldPath(field) {
        if (!this.props.sub_cmps) {
            return null;
        }
        const fieldCmp = this.props.sub_cmps.find(
            item => item.cmp_data && item.cmp_data.field_name === field
        );
        if (
            fieldCmp &&
            fieldCmp.cmp_data &&
            fieldCmp.cmp_data.hasOwnProperty('metaFieldRelationIDPath')
        ) {
            return fieldCmp.cmp_data.metaFieldRelationIDPath;
        }

        return null;
    }

    formatSearchFormData(biz_data) {
        const { cmp_data } = this.props;
        let items = [];
        for (let prop in biz_data) {
            const isInvalid =
                !biz_data[prop].text &&
                biz_data[prop].text !== 0 &&
                (!biz_data[prop].value && biz_data[prop].value !== 0);
            if (!isInvalid) {
                let searchItem = {
                    name: prop,
                    text: biz_data[prop].text,
                    value: biz_data[prop].value,
                    num: '',
                    metaObjName: ''
                };
                if (biz_data[prop].hasOwnProperty('num')) {
                    searchItem.num = biz_data[prop].num;
                }

                const metaFieldRelationIDPath = this.getMetaFieldPath(prop);
                if (metaFieldRelationIDPath !== null) {
                    searchItem.metaFieldRelationIDPath = metaFieldRelationIDPath;
                }

                items.push(searchItem);
            }
        }

        if (this.props.customview_biz_data) {
            this.props.customview_biz_data.map(item => {
                items.push(item);
            });
        }

        return {
            metaObjName: cmp_data.metaObjectName,
            searchView: cmp_data.viewName,
            items: items,
            searchFormFilterJson: cmp_data.filterJson
        };
    }

    getSearchData(e) {
        this.handleSearchFormValidate().then(() => {
            // 点击确定按钮 将临时数据同步到biz_data 关闭弹窗  更新列表
            !this.props.isLookupAdvanced &&
                this.props.actions.updateBizData(this.props.cmp_id);
            this.props.handleClosePopUp && this.props.handleClosePopUp();
        });

        // setTimeout(() => {
        //     this.props.reloadTable({ searchData: this.formatSearchFormData() });
        // }, 350);
    }

    handleResetFormData(e) {
        e.preventDefault();
        if (this.props.isLookupAdvanced) {
            this.props.resetLookupFormData && this.props.resetLookupFormData();
            return;
        }
        this.props.actions.resetFormData(this.props.cmp_id);
    }
    isObjectEmpty(obj) {
        return (
            typeof obj === 'undefined' ||
            (Object.keys(obj).length === 0 &&
                JSON.stringify(obj) === JSON.stringify({}))
        );
    }
    extracValidators(tree, validators) {
        //目前只对整数、小数、长整数进行校验
        if (
            tree.validators &&
            !this.isObjectEmpty(tree.validators) &&
            !isInvisible(tree.cmp_data) &&
            ['BC_TextBoxRange', 'BC_DigitText'].indexOf(tree.cmp_type) >= 0
        ) {
            const field = 'biz_data_key';
            validators[tree.cmp_data[field]] = tree.validators;
            return true;
        }
        if (tree.sub_cmps && tree.sub_cmps.length > 0) {
            tree.sub_cmps.forEach(item => {
                this.extracValidators(item, validators);
            });
        }
        return false;
    }

    getValidatorConstraints() {
        let constraints = {};
        this.extracValidators(this.props, constraints);
        return constraints;
    }
    //用于处理搜索表单的逻辑
    handleSearchFormValidate() {
        return new Promise((res, rej) => {
            const { sub_cmps, tempSearchData, cmp_id } = this.props;
            let newTempSearchData = Object.assign({}, tempSearchData);
            //将最后改变的值添加进去
            const lastChangedValue = this.refs.searchForm.lastChangedValue;
            if (lastChangedValue) {
                for (let key in lastChangedValue) {
                    if (lastChangedValue.hasOwnProperty(key)) {
                        newTempSearchData[key] = lastChangedValue[key];
                    }
                }
            }
            //对搜索表单提交前进行校验
            const constraints = this.getValidatorConstraints();
            this.props.actions.validate_searchForm(
                sub_cmps,
                newTempSearchData,
                constraints,
                cmp_id,
                () => {
                    res();
                },
                () => {
                    //失败回调
                    rej();
                }
            );
        });
    }
    handleSubmit() {
        //为了解决最后一个字段失焦触发的searchFieldChangeAdapter的action不会触发区域字段组件的更新，所以加了100ms的延时
        setTimeout(() => {
            this.handleSearchFormValidate()
                .then(() => {
                    //  成功回调
                    if (this.props.isLookupAdvanced) {
                        this.props.submit && this.props.submit();
                    } else {
                        // 点击确定的时候需要将tempSearchData的数据同步到biz_data
                        this.props.actions.updateBizData(this.props.cmp_id);
                    }
                    setTimeout(() => {
                        this.props.handleClosePopUp();
                    }, 350);
                })
                .catch(() => {});
        }, 100);
    }

    getSubCmpsArr() {
        const { translation } = this;
        let button_all = {
            cls: 'search-all',
            biz_data: {},
            cmp_id: '0',
            cmp_data: {
                cmp_state: 'search',
                searchdisplaystate: 'readonly',
                field_name: '',
                biz_data_key: ''
            },
            cmp_label: translation.allFilters,
            cmp_type: 'BC_Button',
            style: {
                fontSize: '16px',
                color: '#007ed9',
                margin: '20px 0 13px'
            },
            icon: {
                position: 'right',
                className: this.allClass,
                color: '#007ed9',
                fontSize: '18px'
            },
            onButtonTouchTap: this.handleButtonToggleData
        };

        let sub_cmpsArr = this.props.sub_cmps.filter(item => {
            return item.cmp_data.searchdisplaystate != 'invisible';
        });
        sub_cmpsArr.forEach((item, index) => {
            if (
                (item.cmp_type === 'BC_DropDownList' ||
                    item.cmp_type === 'BC_CheckBoxList') &&
                this.props.pop_type == 'searchList'
            ) {
                item = Object.assign(item, {
                    cmp_type: 'BC_DataBlockList',
                    origin_type: item.cmp_type
                });
            }
            // 解决由于点击筛选 后点击筛选项cmp_type改变的问题
            if (
                index == 0 &&
                item.cmp_type === 'BC_DataBlockList' &&
                this.props.pop_type == 'searchItem'
            ) {
                item = Object.assign(item, { cmp_type: item.origin_type });
            }
        });

        const dataSource = this.props.cmp_data.datasource;
        if (dataSource && dataSource.length > 0) {
            dataSource.forEach(source => {
                for (let i = 0, len = sub_cmpsArr.length; i < len; i++) {
                    let item = sub_cmpsArr[i];
                    if (!source) {
                        break;
                    }
                    if (item.cmp_data.datasourcename === source.key) {
                        Object.assign(item, {
                            biz_data: source.dataSourceResults
                        });
                    }
                }
            });
        }

        const sublen = sub_cmpsArr.length;
        if (!this.state.isExpand) {
            sub_cmpsArr = sub_cmpsArr.slice(0, 5);
        }
        if (sublen > 5) {
            sub_cmpsArr.splice(5, 0, button_all);
        }
        return sub_cmpsArr;
    }

    render() {
        const { translation } = this;
        const props = Object.assign({}, this.props, {
            sub_cmps: this.getSubCmpsArr()
        });
        const SearchFormExt = getExtensionCmp(props) || Form;
        const style_button = {
            color: '#fff',
            fontSize: '16px',
            background: '#1695F0',
            lineHeight: '44px',
            height: '44px'
        };
        const style_reset = {
            color: '#1E80C7',
            fontSize: '16px',
            background: '#fff',
            lineHeight: '44px',
            height: '44px'
        };
        return this.props.pop_type !== 'searchItem' ? (
            <Page
                cls={
                    this.state.isExpand
                        ? 'search-form'
                        : 'search-form my-searchForm'
                }>
                <Content ref="pageContent" onTouchMove={this.onTouchMove}>
                    <SearchFormExt
                        ref="searchForm"
                        {...props}
                        formType={'searchForm'}
                        pop_type={this.props.pop_type}
                    />
                </Content>
                <Footer cls="search-form-footer">
                    <SafeAreaWrap safeAreaStyle={{ background: '#ffffff' }}>
                        <div className="search-form-button border-1px">
                            <Button
                                cmp_label={translation.reset}
                                style={style_reset}
                                padding="0px"
                                onTouchTap={this.handleResetFormData}
                            />
                        </div>
                        <div className="search-form-button">
                            <Button
                                cmp_label={translation.confirm}
                                style={style_button}
                                padding="0px"
                                onTouchTap={this.handleSubmit}
                            />
                        </div>
                    </SafeAreaWrap>
                </Footer>
            </Page>
        ) : (
            <SearchFormExt
                ref="searchForm"
                {...props}
                formType={'searchForm'}
                pop_type={this.props.pop_type}
                synBizData={this.getSearchData}
            />
        );
    }
}

SearchForm.PropTypes = {
    params: React.PropTypes.object.isRequired
};

export default SearchForm;



// WEBPACK FOOTER //
// ./src/components/Form/SearchForm.js